import * as types from 'actions/actionTypes';
import initialState from 'reducers/initialState';

export default (state = initialState.reachedFirstDay, action) => {
  switch (action.type) {
    case types.CALENDAR_NO_PAST_DATA:
      return true;

    case types.LOG_OUT.SUCCESS:
      return initialState.reachedFirstDay;

    default:
      return state;
  }
};
